module.exports = __webpack_public_path__ + "img/xlb.1e0bb2b7.png";